"use strict";
var invariant = require("invariant");
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(exports.DocumentType || (exports.DocumentType = {}));
var DocumentType = exports.DocumentType;
function parser(document) {
    var variables, type, name;
    invariant((!!document || !!document.kind), "Argument of " + document + " passed to parser was not a valid GraphQL Document. You may need to use 'graphql-tag' or another method to convert your operation into a document");
    var fragments = document.definitions.filter(function (x) { return x.kind === 'FragmentDefinition'; });
    var queries = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'query'; });
    var mutations = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'mutation'; });
    var subscriptions = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'subscription'; });
    if (fragments.length && (!queries.length || !mutations.length || !subscriptions.length)) {
        invariant(true, "Passing only a fragment to 'graphql' is not yet supported. You must include a query, subscription or mutation as well");
    }
    if (queries.length && mutations.length && mutations.length) {
        invariant(((queries.length + mutations.length + mutations.length) > 1), "react-apollo only supports a query, subscription, or a mutation per HOC. " + document + " had " + queries.length + " queries, " + subscriptions.length + " subscriptions and " + mutations.length + " muations. You can use 'compose' to join multiple operation types to a component");
    }
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length ? queries :
        (mutations.length ? mutations : subscriptions);
    if (definitions.length !== 1) {
        invariant((definitions.length !== 1), "react-apollo only supports one defintion per HOC. " + document + " had " + definitions.length + " definitions. You can use 'compose' to join multiple operation types to a component");
    }
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    var hasName = definition.name && definition.name.kind === 'Name';
    name = hasName ? definition.name.value : 'data';
    return { name: name, type: type, variables: variables };
}
exports.parser = parser;
//# sourceMappingURL=parser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-apollo/lib/parser.js
// module id = 475
// module chunks = 0 1